import {
	createResource,
	type RouterDataContext,
	type ResourceStoreContext,
} from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import { checkLicense } from '@atlassian/jira-spa-apps-common/src/interceptors/license/index.tsx';
import { fetchJson } from '@atlassian/jira-fetch/src/index.tsx';
import getServiceDeskData from '@atlassian/jira-router-resources-service-desk-context/src/services/get-data/index.tsx';
import type { PillsResponse } from './types.tsx';
import { RESOURCE_TYPE_DRAFT_REPLY_PILLS } from './constants.tsx';

export const draftReplyPillsResource = createResource<PillsResponse | null>({
	type: RESOURCE_TYPE_DRAFT_REPLY_PILLS,
	getKey: ({ match, query }) => {
		const issueKey = match.params.issueKey || query.selectedIssue || '';

		return `draftReplyPillsResource-${issueKey}`;
	},
	getData: async (
		routerDataContext: RouterDataContext,
		resourceStoreContext: ResourceStoreContext,
	) => {
		const issueKey =
			routerDataContext.match.params.issueKey || routerDataContext.query.selectedIssue || '';

		if (!issueKey) {
			return null;
		}

		// Check if service desk is enabled
		if (
			!checkLicense(resourceStoreContext.tenantContext, 'servicedesk') ||
			!fg('jsm_issue_view_ai_context')
		) {
			return null;
		}

		// Serviedesk context call to identify agent permission
		// if role is not agent-project-admin or agent then return null
		const serviceDeskContext = await getServiceDeskData(routerDataContext, resourceStoreContext);
		if (
			!(
				serviceDeskContext.userRole === 'agent-project-admin' ||
				serviceDeskContext.userRole === 'agent'
			)
		) {
			return null;
		}

		try {
			const endpoint = `/gateway/api/firebolt/1/agent-response/pills/work-item/${issueKey}`;
			const response = await fetchJson<PillsResponse>(endpoint, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				},
			});
			return response;
		} catch (error) {
			return null;
		}
	},
	maxAge: 0,
	isBrowserOnly: true,
});

export const getDraftReplyPillsResource = () => {
	return fg('router_call_for_draft_reply') ? [draftReplyPillsResource] : [];
};
